import React from "react";
import {
  MapPin,
  Phone,
  Mail,
} from "lucide-react";
import { FaFacebookF, FaInstagram } from "react-icons/fa";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="w-full bg-black text-white">
      {/* ================= MAIN FOOTER ================= */}
      <div className="mx-auto max-w-7xl px-6 py-16 sm:px-8 lg:px-12">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-4">

          {/* ================= LOGO & ABOUT ================= */}
          <div className="lg:col-span-2">
            <Link to="/" className="inline-block">
              <img
                src="/download.png"
                alt="Capeesh Craft Kitchen & Cellar"
                className="h-auto w-[180px] object-contain brightness-0 invert"
              />
            </Link>

            <p className="mt-6 max-w-xl text-sm leading-7 text-gray-400">
              No theme. No boundaries. No rules. Proudly Canadian with a
              little bit of everything — handmade pizza, gourmet pasta, and
              two riverside patios overlooking the Grand River.
            </p>

            {/* ================= SOCIAL ICONS ================= */}
            <div className="mt-7 flex items-center gap-4">
              {/* FACEBOOK */}
              <a
                href="https://www.facebook.com/CapeeshKitchenAndCellar"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="flex h-11 w-11 items-center justify-center rounded-full border border-gray-700 text-white transition-all duration-300 hover:border-white hover:bg-white hover:text-black"
              >
                <FaFacebookF className="h-5 w-5" />
              </a>

              {/* INSTAGRAM */}
              <a
                href="https://www.instagram.com/capeeshcraftkitchen"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="flex h-11 w-11 items-center justify-center rounded-full border border-gray-700 text-white transition-all duration-300 hover:border-white hover:bg-white hover:text-black"
              >
                <FaInstagram className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* ================= NAVIGATION ================= */}
          <div>
            <h3 className="mb-6 text-sm font-bold uppercase tracking-[0.2em] text-white">
              Navigation
            </h3>

            <ul className="space-y-4">
              <li>
                <Link
                  to="/"
                  className="text-sm text-gray-400 transition hover:text-white"
                >
                  Home
                </Link>
              </li>

              <li>
                <Link
                  to="/reservation"
                  className="text-sm text-gray-400 transition hover:text-white"
                >
                  Reservation
                </Link>
              </li>

              <li>
                <Link
                  to="/about"
                  className="text-sm text-gray-400 transition hover:text-white"
                >
                  About
                </Link>
              </li>

              <li>
                <Link
                  to="/menu"
                  className="text-sm text-gray-400 transition hover:text-white"
                >
                  Menu
                </Link>
              </li>

              <li>
                <Link
                  to="/contact"
                  className="text-sm text-gray-400 transition hover:text-white"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* ================= CONTACT ================= */}
          <div>
            <h3 className="mb-6 text-sm font-bold uppercase tracking-[0.2em] text-white">
              Contact
            </h3>

            <div className="space-y-5">

              {/* LOCATION - GOOGLE MAP LINK */}
              <a
                href="https://www.google.com/maps/search/?api=1&query=Capeesh+Craft+Kitchen+%26+Cellar+Grand+River+Canada"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Open Capeesh Craft Kitchen & Cellar in Google Maps"
                className="group flex items-start gap-3"
              >
                <MapPin
                  size={19}
                  className="mt-1 shrink-0 text-gray-400 transition-colors duration-300 group-hover:text-white"
                />

                <p className="text-sm leading-6 text-gray-400 transition-colors duration-300 group-hover:text-white">
                  Capeesh Craft Kitchen & Cellar
                  <br />
                  Grand River, Canada
                </p>
              </a>

              {/* PHONE */}
              <a
                href="tel:+1 (548) 899-0050"
                className="flex items-center gap-3 text-sm text-gray-400 transition hover:text-white"
              >
                <Phone size={18} />
                <span>+1 (548) 899-0050</span>
              </a>

              {/* EMAIL */}
              <a
                href="mailto:capeeshrestaurant@gmail.com"
                className="flex items-center gap-3 text-sm text-gray-400 transition hover:text-white"
              >
                <Mail size={18} />
                <span>capeeshrestaurant@gmail.com</span>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* ================= BOTTOM FOOTER ================= */}
      <div className="border-t border-gray-800">
        <div className="mx-auto flex min-h-[70px] max-w-7xl items-center justify-center px-6 py-5">
          <p className="whitespace-nowrap text-center text-xs text-gray-500 sm:text-sm">
            Copyright 2025 | All Rights Reserved | Capeesh Kitchen and Cellar
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;